var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_setup.hasError)?_c('div',{directives:[{name:"intersect",rawName:"v-intersect",value:({ handler: _setup.observerCallback, options: _vm.observerOptions }),expression:"{ handler: observerCallback, options: observerOptions }"}]},[_vm._t("default")],2):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }